import { render, staticRenderFns } from "./UserExcuseView.vue?vue&type=template&id=138e9916"
import script from "./UserExcuseView.vue?vue&type=script&lang=js"
export * from "./UserExcuseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports